import { NavLink, useSearchParams } from 'react-router-dom'
import { useSession } from '../../session'

// Tabs across the top of every Purchase list page, like the Sales tabs.
// Approvals only shows for admins, with the number waiting.
export default function PurchaseTabs() {
  const { roles, approvals, has } = useSession()
  // All / For resale / Materials follows you across the list tabs.
  const [params] = useSearchParams()
  const itemFor = has('production') && ['resale', 'materials'].includes(params.get('for')) ? `?for=${params.get('for')}` : ''
  const isAdmin = roles.includes('admin')
  // Without Purchase (the Invoices plan) there are only service invoices and payments.
  const tabs = !has('purchase') ? [
    { to: '/purchase/invoices', label: 'Vendor invoices' },
    { to: '/purchase/ap-ledger', label: 'Payments' },
  ] : [
    { to: '/purchase', label: 'Summary', end: true },
    { to: '/purchase/po-list', label: 'Orders', keep: true },
    { to: '/purchase/receipts', label: 'Receiving', keep: true },
    { to: '/purchase/invoices', label: 'Vendor invoices', keep: true },
    { to: '/purchase/vendor-returns', label: 'Returns', keep: true },
    { to: '/purchase/ap-ledger', label: 'Payments' },
    // Without Inventory, stock is valued at each month's end (the periodic method).
    ...(!has('inventory') ? [{ to: '/purchase/stock-value', label: 'Stock value' }] : []),
    ...(isAdmin ? [{ to: '/purchase/po-approval-inbox', label: 'Approvals', count: approvals.po }] : []),
  ]
  return (
    <nav className="section-tabs" aria-label="Purchase">
      {tabs.map(({ to, label, end, count, keep }) => (
        <NavLink key={to} to={keep ? to + itemFor : to} end={end}>
          {label}
          {count > 0 && <span className="section-tab-count">{count}</span>}
        </NavLink>
      ))}
    </nav>
  )
}
